import { SearchParamKey } from '@app/store/appStore.types'

export const SESSION_SEARCH_PARAMS = [
    SearchParamKey.ACCESS_TOKEN,
    SearchParamKey.REFRESH_TOKEN,
    SearchParamKey.REDIRECT_URL,
]

export const PERSISTENT_SEARCH_PARAMS = [
    SearchParamKey.COMPANY_INVITE_ID,
    SearchParamKey.REF_CODE,
]
